// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/node_modules/.pnpm/next@16.2.4_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/esm/client/components/client-page.js"));
